/** @jsx jsx */
import { jsx, Flex } from "theme-ui";
import { Global } from "@emotion/react";

import SEO from "./SEO";
import Header from "./Header";
import Footer from "./Footer";

const Layout = ({ title, description, image, children }) => {

  const globalStyles = {
    "html": {
      scrollBehavior: "auto",
      /* Without this, Archivo renders too bold on Mac */
      "MozOsxFontSmoothing": "grayscale",
      "WebkitFontSmoothing": "antialiased"
    }
  };

  return (
    <Flex sx={{flexDirection: "column", minHeight:"100vh"}}>
      <SEO title={title} description={description} image={image} />
      <Global styles={_theme => globalStyles}/>

      <Header />
      <main sx={{flexGrow: 1}}>
        {children}
      </main>
      <Footer />

    </Flex>
  );
};

export default Layout;
